import { styled } from "goober";
import { Button } from "./Button";

// Secondary button with a soft tinted fill, used for low-emphasis CTAs such as
// the "Ask 3B to …" actions in empty states.
export const SoftButton = styled(Button)`
  &.secondary {
    background: var(--alpha4);
    &:hover:not(:disabled) {
      background: var(--alpha8);
    }
  }
`;
